import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=5a1ac2e6&scoped=true"
import script from "./guide.vue?vue&type=script&lang=ts"
export * from "./guide.vue?vue&type=script&lang=ts"
import style0 from "./guide.vue?vue&type=style&index=0&id=5a1ac2e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1ac2e6",
  null
  
)

export default component.exports